module.exports = require('./helpers/bundle-url').getBundleURL('jJ61j') + "logo-dark.eefe0b7f.svg";